/* eslint-disable jsx-a11y/label-has-for */

import Bg from 'assets/images/SMSSentDialog.svg';
import { useTranslation } from 'providers/GILT.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import PopupHeader from 'clientCommunications/components/Clients/ConfirmationModal/PopupHeader';

const SmsSentDialog = (props) => {
  const { isModalAction, history, sms_credits_available, backToCalendar } = props;
  const { t } = useTranslation();
  return (
    <div data-bem="SmsSentDialog" className="dialog-container-marketing">
      <div className="popup-2-button animated zoomIn">
        <PopupHeader
          isModalAction={isModalAction}
          onClose={alwaysNoop}
          history={history}
          style={{ background: `Url(${Bg})`, height: '286px', borderRadius: '4px' }}
        >
          <div className="flex-center">
            <div className="modal-content">
              <div className="sms-title">
                <div>{t('scheduler.smsButton.messageSent')}</div>
              </div>

              <p className="uniq-note">
                {t('scheduler.smsButton.remainingCredits', { credits: sms_credits_available })}
              </p>
              <br />
            </div>
          </div>
        </PopupHeader>
        <div className="footer-marketing-sendsms cfix fromMarketing">
          <div className="marketing-button-container">
            <button className="sms-btn-white" onClick={backToCalendar}>
              {t('common.buttons.back')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsSentDialog;
